import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {
    MasterSummaryQuestionModel,
    SimpleSurveyQuestion,
    SurveySummaryAnswerFilter,
    MasterSummaryPDModel,
    SurveyCutQuestionModel, SurveyVersionQuestionModel, MasterSummaryAnswerModel
} from '../../../../models/survey/survey.model';
import {
  allowShowBarchart,
  allowShowPieChart,
  generateIncludeVersionLabel,
  showAverageNumericResponse,
  showMostCommonResponse,
  allowShowWordCloud,
} from '../../../../shared/helpers/chart-helper';
import {Observable} from 'rxjs/Observable';
import {SurveyService} from '../../surveys.service';
import {ToasterService} from 'angular5-toaster/dist/angular5-toaster';

import { SummaryFilterModel } from '../../../../models/summary/summary.model';
import { SortType } from '../../../../shared/constants/sort.constants';
import { PercentageIconComponent } from '../icon-dropdown/percentage-icon/percentage-icon.component';
import { ChartName } from '../../../../shared/constants/chart.constants';
import { AuthTokenService } from '../../../../shared/services/auth-token.service';
import Utils from '../../../../shared/util/Util';
import {PercentageType} from '../../../../shared/constants/percentage.constants';
import {ChartingService} from '../../charting.service';

const MAX_LENGTH_TITLE = 30;

@Component({
  selector: 'app-charting',
  templateUrl: './charting.component.html',
  styleUrls: ['./charting.component.less']
})
export class ChartingComponent implements OnInit {
  @Input() isCompareMode = false;
  @Input() dataOrdered: any;
  @Input() isTranslate = false;
  @Output() themeModeSelected = new EventEmitter<any[]>();
  @Output() sortModeSelected = new EventEmitter<any>();
  @Output() onTranlateAction = new EventEmitter<any>();
  @Output() onPercentageSelect = new EventEmitter<any>();

  @ViewChild('screen') screen: ElementRef;
  @ViewChild('canvas') canvas: ElementRef;
  @ViewChild('downloadLink') downloadLink: ElementRef;

  question: MasterSummaryQuestionModel;
  _originalArrayChart = [];
  questionValue: MasterSummaryQuestionModel;
  showDropdownChartType = false;
  tableDataLabel = ChartName.TABLE_DATA;
  barChartLabel = ChartName.BAR_CHART;
  roseChartLabel = ChartName.ROSE_CHART;
  averageChartLabel = ChartName.AVERAGE_CHART;
  mostCommonChartLabel = ChartName.MOST_COMMON_CHART;
  // word cloud
  wordCloudChartLabel = ChartName.WORD_CLOUD_CHART;
  // word count
  wordCountChartLabel = ChartName.WORD_COUNT_CHAR;
  // response cloud
  responseCloudChartLabel = ChartName.RESPONSE_CLOUD_CHART;
  // response count
  responseCountChartLabel = ChartName.RESPONSE_COUNT_CHART;
  chartName: string;
  private listening = false;
  private globalClick: any;
  defaultChart = '';
  undefinedName = 'undefined';

  @Input() isMissingQuestion = false;
  @Input() surveyId: number;
  @Input() summaryFilterModel: SummaryFilterModel;
  @Input() isSubgroup = false;
  @Input('surveyMasterSummaryPDModel') survMastSummPDModel: MasterSummaryPDModel;
  @Input('chartJ') chartJ: number;
  @Input('questionI') questionI: number;
  @Input('isCut') isCut: boolean;
  @Input() isAllResponses: boolean;
  @Input() isSelectedAllResponses: boolean;
  private refToPercentageIcon: PercentageIconComponent;

  @Input()
  get questionInput(): MasterSummaryQuestionModel {
    return this.questionValue;
  }

  set questionInput(val) {
    this.questionValue = val;
  }

  listSurveyVersionValue: any;

  @Input()
  get listSurveyVersion() {
    return this.listSurveyVersionValue;
  }

  set listSurveyVersion(val) {
    if (Array.isArray(val)) {
      if (val.length >= 1) {
        this.listSurveyVersionValue = val;
      }
    } else {
      this.listSurveyVersionValue = [val];
    }

    this.label = generateIncludeVersionLabel(false, this.listSurveyVersionValue);
    if (this.label) {
      if (this.label.length > MAX_LENGTH_TITLE) {
        this.shortLabel = this.label.substring(0, MAX_LENGTH_TITLE) + '...';
      } else {
        this.shortLabel = this.label;
      }
    }
  }

  @Input() chartModeInput: string;

  @Input() subgroupAnswerResponse: string;

  @Input() subgroupAnswerQuestion: SimpleSurveyQuestion;

  @Output() chartModeSelected = new EventEmitter<any>();

  @Input() chartDisplay: string;

  @Input() isHideRadioButton: boolean;

  @Input() showDownloadAllChartsIcon = false;
  @Input() questionNumber: number;
  @Input() fromSmartAnalysis = false;

  surveyTitle: string;

  listSurveySummaryAnswerFilter: SurveySummaryAnswerFilter[] = [];

  label: string;
  shortLabel: string;
  id: number = null;
  totalResponse = 0;
  themeModeSelect = undefined;
  isShowWordCloud = AuthTokenService.isShowWordCloud();
  constructor(private surveyService: SurveyService,
              private cdRef: ChangeDetectorRef,
              private chartingService: ChartingService,
              private toast: ToasterService) {
  }

    ngOnInit() {
        this.surveyService.getTitleSurvey(this.surveyId).subscribe(res => {
            this.surveyTitle = res;
        });

        this.question = Object.assign({}, this.questionInput);

        this.themeModeSelect = this.question.themeModeSelect;
        this.setDefaultChart();
        this.getChartName();
        this.getOriginalArrayChart();

        this.cdRef.detectChanges();
        if (this.chartModeInput) {
            this.updateAttrQuestionByChartMode(this.chartModeInput);
        } else if (!this.isCompareMode) {
            this.chartModeSelected.emit(this.chartName);
        }

        if (this.question.answerType === 'MultipleChoice') {
            this.totalResponse = this.question.peopleReponsesCount;
        } else {
            if (this.question.listAnswerModel && this.question.listAnswerModel.length !== 0) {
                this._originalArrayChart.forEach(answer => {
                    this.totalResponse += answer.answerCount;
                });
            } else {
                this.totalResponse += this.question.answeredCount;
            }
        }
        this.validateTheme();
        this.validateChartType();
        this.generateNizPitanja();
        if (this.isCompareMode) {
            this.question.listAnswerModel = this.questionValue.listAnswerModel;
            this.question.nizPitanja = this.questionValue.nizPitanja;
        }
        this.validateSort();

        // Calculate when Chart have theme is on
        if (this.hasAnswerTheme && this.themeModeSelect === true) {
            this.chartingService.updateListAnswerForQuestionWhenThemeIsOn(this.question, this.survMastSummPDModel, this.questionI,
                this.chartJ, this.isCompareMode, this.hasAnswerTheme, this.isAllResponses);
        }
    }

  setDefaultChart() {
    if (this.question.defaultChart) {
      this.defaultChart = this.question.defaultChart.chart;
    } else {
      this.defaultChart = this.chartDisplay;
    }
  }

  validateChartType(): void {
    if (this.question.chartModeSelect && this.isCompareMode) {
      this.updateAttrQuestionByChartMode(this.question.chartModeSelect);
    }
  }

  validateSort(): void {
    if (this.question.sortModeSelect && this.isCompareMode) {
      this.onUpdatedSortCompare(this.question.sortModeSelect);
    }
  }

  validateTheme(): void {
    if (this.themeModeSelect && this.isCompareMode) {
      this._onThemeActionCompare(this.themeModeSelect);
      this.validateSort();
    }
  }

  allowShowBarChart(type: string): boolean {
    return allowShowBarchart(type);
  }

  allowShowPieChart(type: string): boolean {
    return allowShowPieChart(type);
  }

  allowShowWordCloud(type: string): boolean {
    return this.isShowWordCloud && allowShowWordCloud(type);
  }
  showAverageNumericResponse(type: string): boolean {
    return showAverageNumericResponse(type);
  }

  showMostCommonResponse(type: string): boolean {
    return showMostCommonResponse(type);
  }

  changeModeChartDisplay(chartMode: string, defaultChart: string) {
    this.updateAttrQuestionByChartMode(chartMode);
    this.chartName = chartMode;
    this.defaultChart = defaultChart;

    this.chartModeSelected.emit(
        {chartMode: chartMode, defaultChart: defaultChart}
    );
  }

  showBarChartPieChart(barChart: boolean) {
    this.question.barChart = barChart;
    this.question.chart = !barChart;
    this.question.averageResponse = false;
    this.question.mostCommonResponse = false;
    this.question.tableData = false;
    this.question.wordCloudResponse = false;
    this.question.wordCountResponse = false;
    // response cloud
    this.question.responseCloudResponse = false;
    this.question.responseCountResponse = false;
    this.chartName = barChart ? this.barChartLabel : this.roseChartLabel;
  }

  showAverageNumericChart() {
    this.question.averageResponse = true;
    this.question.mostCommonResponse = false;
    this.question.barChart = false;
    this.question.chart = false;
    this.question.tableData = false;
    this.question.wordCloudResponse = false;
    this.question.wordCountResponse = false;
    // response cloud
    this.question.responseCloudResponse = false;
    this.question.responseCountResponse = false;
    this.chartName = this.averageChartLabel;
  }

  showCommonNumericChart() {
    this.question.mostCommonResponse = true;
    this.question.barChart = false;
    this.question.chart = false;
    this.question.averageResponse = false;
    this.question.tableData = false;
    this.question.wordCloudResponse = false;
    this.question.wordCountResponse = false;
    // response cloud
    this.question.responseCloudResponse = false;
    this.question.responseCountResponse = false;
    this.chartName = this.mostCommonChartLabel;
  }

  showTableData() {
    this.question.mostCommonResponse = false;
    this.question.barChart = false;
    this.question.chart = false;
    this.question.averageResponse = false;
    this.question.tableData = true;
    this.question.wordCloudResponse = false;
    this.question.wordCountResponse = false;
    // response cloud
    this.question.responseCloudResponse = false;
    this.question.responseCountResponse = false;
    this.chartName = this.tableDataLabel;
  }

  showWordCloud() {
    this.question.mostCommonResponse = false;
    this.question.barChart = false;
    this.question.chart = false;
    this.question.averageResponse = false;
    this.question.tableData = false;
    this.question.wordCloudResponse = true;
    this.question.wordCountResponse = false;
    // response cloud
    this.question.responseCloudResponse = false;
    this.question.responseCountResponse = false;
    this.chartName = this.wordCloudChartLabel;
  }
  showWordCount() {
    this.question.mostCommonResponse = false;
    this.question.barChart = false;
    this.question.chart = false;
    this.question.averageResponse = false;
    this.question.tableData = false;
    this.question.wordCloudResponse = false;
    this.question.wordCountResponse = true;
    // response cloud
    this.question.responseCloudResponse = false;
    this.question.responseCountResponse = false;
    this.chartName = this.wordCountChartLabel;
  }

  showResponseCloud() {
    this.question.mostCommonResponse = false;
    this.question.barChart = false;
    this.question.chart = false;
    this.question.averageResponse = false;
    this.question.tableData = false;
    this.question.wordCloudResponse = false;
    this.question.wordCountResponse = false;
    this.question.responseCloudResponse = true;
    this.question.responseCountResponse = false;
    this.chartName = this.responseCloudChartLabel;
  }
  showResponseCount() {
    this.question.mostCommonResponse = false;
    this.question.barChart = false;
    this.question.chart = false;
    this.question.averageResponse = false;
    this.question.tableData = false;
    this.question.wordCloudResponse = false;
    this.question.wordCountResponse = false;
    this.question.responseCloudResponse = false;
    this.question.responseCountResponse = true;
    this.chartName = this.responseCountChartLabel;
  }
  getChartName() {
      this.chartName = this.question.barChart ? this.barChartLabel :
      this.question.chart ? this.roseChartLabel :
      this.question.averageResponse ? this.averageChartLabel :
      this.question.mostCommonResponse ? this.mostCommonChartLabel :
      this.question.wordCloudResponse ?  this.wordCloudChartLabel :
      this.question.responseCloudResponse ?  this.responseCloudChartLabel :
      this.question.responseCountResponse ?  this.responseCountChartLabel :  this.tableDataLabel;
  }

  updateAttrQuestionByChartMode(chartMode: string) {

    switch (chartMode) {
      case this.barChartLabel:
        this.showBarChartPieChart(true);
        break;
      case this.roseChartLabel:
        this.showBarChartPieChart(false);
        break;
      case this.averageChartLabel:
        this.showAverageNumericChart();
        break;
      case this.mostCommonChartLabel:
        this.showCommonNumericChart();
        break;
      case this.tableDataLabel:
        this.showTableData();
        break;
      case this.wordCloudChartLabel:
        this.showWordCloud();
        break;
      case this.wordCountChartLabel:
        this.showWordCount();
        break;
      case this.responseCloudChartLabel:
        this.showResponseCloud();
        break;
      case this.responseCountChartLabel:
        this.showResponseCount();
        break;
    }
  }

  displayDropdownChartType(element) {
    if (!element.target.className || element.target.className.indexOf('radio-label-default-chart') < 0) {
      this.showDropdownChartType = !this.showDropdownChartType;
      if (this.showDropdownChartType) {
        this.globalClick = Observable
          .fromEvent(document, 'click')
          .delay(100)
          .do(() => {
            this.listening = true;
          }).subscribe((event: MouseEvent) => {
            this.onGlobalClick(element, event);
          });
      } else {
        this.listening = false;
        this.globalClick.unsubscribe();
      }
    }
  }

  onGlobalClick(element, event: MouseEvent) {
    if (event instanceof MouseEvent && this.listening === true) {
      if (!this.isDescendant(element.target, event.target)) {
        this.showDropdownChartType = false;
        this.listening = false;
        this.globalClick.unsubscribe();
      }
    }
  }

  isDescendant(parent, child) {
    let node = child;
    while (node !== null) {
      if (node === parent) {
        return true;
      } else {
        node = node.parentNode;
      }
    }
    return false;
  }

  get hasAnswerTheme() {
    const listAnswer = Object.assign([], this._originalArrayChart);
    for (const answer of listAnswer) {
      if (answer.answerTheme) { return true; }
    }
    return false;
  }

  onUpdatedSort(_sortType) {
    let _listOrdered = [];
    // localStorage.setItem( 'question', JSON.stringify(this.question.listAnswerModel));
    if (_sortType !== this.question.sortModeSelect || (this.isCompareMode && this.question.diffSortModeSelected !== this.listSurveyVersion[0].surveyName)) {
        if (this.question.listAnswerModel && this.question.listAnswerModel.length > 0) {
        this.question.listAnswerModel = this.sortDataChart(_sortType);
        _listOrdered = this.assignOrderSequenceBase(this.question.listAnswerModel);
        this.question.sortModeSelect = _sortType;
        } else if (this.question.listAnswerModel && this.question.listAnswerModel.length === 0 && this.question.nizPitanja) {
        this.question.nizPitanja = this.sortDataChart(_sortType);
        _listOrdered = this.assignOrderSequenceBase(this.question.nizPitanja);
        this.question.sortModeSelect = _sortType;
        }
        const _dataEmit = {
        _baseSurvey: this.listSurveyVersion[0].surveyName,
        _listOrdered,
        _sortType
        };

        this.sortModeSelected.emit(_dataEmit);
    }
  }

  onUpdatedSortCompare(_sortType) {
    if (this.question.listAnswerModel && this.question.listAnswerModel.length > 0) {
      this.question.listAnswerModel = this.assignOrderSequenceOthers(this.question.listAnswerModel);
    } else if (this.question.listAnswerModel && this.question.listAnswerModel.length === 0 && this.question.nizPitanja) {
      this.question.nizPitanja = this.assignOrderSequenceOthers(this.question.nizPitanja);
    }
  }

  _onThemeAction(_isOnTheme) {
    const listGrouped = this._onGroupAnswerByTheme(_isOnTheme);
    if (this.question.listAnswerModel && this.question.listAnswerModel.length > 0) {
      this.changeListAnswerModel(_isOnTheme, listGrouped);
    } else if (this.question.listAnswerModel && this.question.listAnswerModel.length === 0 && this.question.nizPitanja) {
      this.changeListNizPitanja(_isOnTheme, listGrouped);
    }
    this.themeModeSelected.emit(_isOnTheme);
    if (this.refToPercentageIcon && this.question.resetPercentagesCalculus) {
      this.refToPercentageIcon.resetAllChart();
    }
    if (!this.isCompareMode) {
        this.question.sortModeSelect = SortType.RESET;
    }
  }

  _onThemeActionCompare(_isOnTheme) {
    const listGrouped = this._onGroupAnswerByTheme(_isOnTheme);
    if (this.question.listAnswerModel && this.question.listAnswerModel.length > 0) {
      this.question.listAnswerModel = listGrouped ? listGrouped : this.question.listAnswerModel;
    } else if (this.question.listAnswerModel && this.question.listAnswerModel.length === 0 && this.question.nizPitanja) {
      this.question.nizPitanja = listGrouped ? listGrouped : this.question.nizPitanja;
    }

    this.totalResponse = 0;
    if (this.question.answerType === 'MultipleChoice') {
      this.totalResponse = this.question.peopleReponsesCount;
    } else {
      if (this.question.listAnswerModel && this.question.listAnswerModel.length !== 0) {
        this._originalArrayChart.forEach(answer => {
          this.totalResponse += answer.answerCount;
        });
      } else {
        this.totalResponse += this.question.answeredCount;
      }
    }
  }

  loadRefOfPercentageIcon(instancePercentageIconComp: PercentageIconComponent) {
    this.refToPercentageIcon = instancePercentageIconComp;
  }

  private _onGroupAnswerByTheme(_isOnTheme) {
    if (!this.isCompareMode && _isOnTheme === undefined && this.hasAnswerTheme) {
      const listAnswerIndexed = this._groupAnswerByTheme();
      return this._generateListToEmit(listAnswerIndexed);
    } else if (!this.isCompareMode && !_isOnTheme && this.hasAnswerTheme) {
      const listAnswerIndexed = this._groupAnswerByTheme();
      return this._generateListToEmit(listAnswerIndexed);
    } else if (!this.isCompareMode && _isOnTheme && this.hasAnswerTheme) {
      return Object.assign([], this._originalArrayChart);
    } else if (_isOnTheme && this.hasAnswerTheme) {
        const listAnswerIndexed = this.chartingService.groupAnswerForTheme(this._originalArrayChart);
        return this.chartingService.makeListToEmit(listAnswerIndexed);
    } else if (!_isOnTheme && this.hasAnswerTheme) {
      return Object.assign([], this._originalArrayChart);
    } else {
      return null;
    }
  }

  private _groupAnswerByTheme() {
    const _listToReduce = Object.assign([], this._originalArrayChart);
    return _listToReduce.reduce((acc, el) => {
      const _answerName = el.answerTheme ? el.answerTheme : this.undefinedName;
      let _answerCount = el.answerCount;
      let _answerPercentage = el.answerPercentage;

      if (acc && acc[_answerName]) {
        _answerCount += 1;
        _answerPercentage += acc[_answerName].answerPercentage;
      } else {
        _answerCount = 1;
      }

      acc[_answerName] = {
        ...el,
        answerName: _answerName,
        answerCount: _answerCount,
        answerPercentage: _answerPercentage
      };

      return acc;
    }, []);
  }

  private assignMapThemes() {
    const _mapThemes = new Map();
    for (const _answer of this._originalArrayChart) {
      if (_answer.answerTheme && _mapThemes.has(_answer.answerTheme)) {
        const _value = _mapThemes.get(_answer.answerTheme);
        if (_answer.countAnswerTheme > _value) {
          _mapThemes.set(_answer.answerTheme, _answer.countAnswerTheme);
        }
      } else if (_answer.answerTheme && !_mapThemes.has(_answer.answerTheme)) {
        _mapThemes.set(_answer.answerTheme, _answer.countAnswerTheme);
      }

      if (!_answer.answerTheme && _mapThemes.has('undefined')) {
        const _value = _mapThemes.get('undefined');
        if (_answer.countAnswerTheme > _value) {
          _mapThemes.set('undefined', _answer.countAnswerTheme);
        }
      } else if (!_answer.answerTheme && !_mapThemes.has('undefined')) {
        _mapThemes.set('undefined', _answer.countAnswerTheme);
      }
    }

    return _mapThemes;
  }

  private _generateListToEmit(_listAnswerIndexed) {
    const _mapThemes = this.assignMapThemes();
    const _listToEmit = [];
    for (const key in _listAnswerIndexed) {
      const el: any = _listAnswerIndexed[key];
      if (this.question.peopleReponsesCount === 0) {
        el.answerCount = 0;
        if (this.question.answerType === 'SingleChoice') {
          el.answerCount = _mapThemes.get(key);
        }
        el.answerPercentage = el.answerPercentage ? Number(el.answerPercentage).toFixed(2) : '0.00';
        _listToEmit.push(el);
      } else {
        el.answerCount = _mapThemes.get(key);
        el.answerPercentage = Number(((el.answerCount / this.question.peopleReponsesCount) * 100).toFixed(2));
        _listToEmit.push(el);
      }
    }

    return _listToEmit;
  }

  isDiffPercSelected(charSelect: number, questionSelected: number) {
    if (!this.survMastSummPDModel) {
      return;
    }
    if (this.isAllResponses) {
      return this.survMastSummPDModel.listQuestionModel[charSelect].diffPercentageSelected;
    } else if (this.isCut) {
      return this.survMastSummPDModel.listSurveyCutQuestion[charSelect].listQuestionModel[questionSelected].diffPercentageSelected;
    } else {
      return this.survMastSummPDModel.listSurveyVersionQuestion[charSelect].listQuestionModel[questionSelected].diffPercentageSelected;
    }
  }

  isDiffPercSelectedAvgRes(charSelect: number, questionSelected: number) {
    if (this.isAllResponses) {
      return this.survMastSummPDModel.listQuestionModel[charSelect].diffPercentageSelectedAvgRes;
    } else if (this.isCut) {
      return this.survMastSummPDModel.listSurveyCutQuestion[charSelect].listQuestionModel[questionSelected].diffPercentageSelectedAvgRes;
    } else {
      return this.survMastSummPDModel.listSurveyVersionQuestion[charSelect].listQuestionModel[questionSelected].diffPercentageSelectedAvgRes;
    }
  }

  private sortDataChart(_sortType): any {
    switch (_sortType) {
      case SortType.ASCENDING:
        return this.sortAscending(this.getSortArrayChart());
      case SortType.DESCENDING:
        return this.sortDescending(this.getSortArrayChart());
      case SortType.ASCENDING_PERCENTAGE:
        return this.sortAscendingPercentage(this.getSortArrayChart());
      case SortType.DESCENDING_PERCENTAGE:
        return this.sortDescendingPercentage(this.getSortArrayChart());
      case SortType.RESET:
        return this.sortDefautByReset(this.getSortArrayChart());
      default:
        return [];
    }
  }

  private assignOrderSequenceBase(listToOrder: any[]): any[] {
    const listOrdered = [];
    for (const data of listToOrder) {
      listOrdered.push(data.answerName);
    }
    return listOrdered;
  }

  private assignOrderSequenceOthers(listToOrder: any[]): any[] {
    if (this.dataOrdered && this.listSurveyVersion && this.dataOrdered._baseSurvey !== this.listSurveyVersion[0] && this.dataOrdered._sortType !== SortType.RESET) {
      const listOrdered = [];
      for (const orderedBase of this.dataOrdered._listOrdered) {
        const findResponse = listToOrder.find( el => el.answerName === orderedBase);
        if (findResponse) { listOrdered.push(findResponse); }
      }
      return (listOrdered && listOrdered.length > 0 ) ? listOrdered : listToOrder;
    } else if (this.dataOrdered && this.listSurveyVersion && this.dataOrdered._baseSurvey !== this.listSurveyVersion[0] && this.dataOrdered._sortType === SortType.RESET) {
      return this.sortDataChart(this.dataOrdered._sortType);
    } else {
      return listToOrder;
    }
  }
  private getOriginalArrayChart(): void {
    if (this.questionValue.copyListAnswerModel && this.questionValue.copyListAnswerModel.length > 0) {
      this._originalArrayChart = Object.assign([], this.questionValue.copyListAnswerModel);
      if (this.themeModeSelect) {
        this._originalArrayChart = Object.assign([], this.questionValue.listAnswerModel);
      }

    } else if (this.questionValue.copyListAnswerModel && this.questionValue.copyListAnswerModel.length === 0 && this.questionValue.copyNizPitanja) {
      this._originalArrayChart = Object.assign([], this.questionValue.listAnswerModel);
      if (this.themeModeSelect) {
        this._originalArrayChart = Object.assign([], this.questionValue.nizPitanja);
      }

    }
  }

  private getSortArrayChart(): any {
    if ( this.question.listAnswerModel && this.question.listAnswerModel.length > 0) {
      return Object.assign([], this.question.listAnswerModel);
    } else if ( this.question.listAnswerModel && this.question.listAnswerModel.length === 0 && this.question.nizPitanja) {
      return Object.assign([], this.question.nizPitanja);
    }
  }

  private getSortArrayPercentageChart(): any {

    if ( this.question.listAnswerModel && this.question.listAnswerModel.length > 0) {
      if (this.listSurveyVersionValue.length > 0) {
        const questionAux = this.survMastSummPDModel.listQuestionModel.find(q => q.id === this.question.id);
        return Object.assign([], questionAux.listAnswerModel);
      }
    } else if ( this.question.listAnswerModel && this.question.listAnswerModel.length === 0 && this.question.nizPitanja) {
      return Object.assign([], this.question.nizPitanja);
    }
  }
  private sortAscending(_originArray): any {
    return _originArray.reduce((sorted, el) => {
      let index = 0;
      while (index < sorted.length && Number(el.answerPercentage) > Number(sorted[index].answerPercentage)) { index++; }
      sorted.splice(index, 0, el);
      return sorted;
    }, []);
  }

  private sortAscendingPercentage(_originArray): any {

    _originArray.forEach(element => {
      element.auxAnswerDiffPercentage = !element.answerDiffPercentage && element.answerDiffPercentage != 0 ? 100 : element.answerDiffPercentage;
    });
    return _originArray.reduce((sorted, el) => {
      let index = 0;
      while (index < sorted.length && el.auxAnswerDiffPercentage > sorted[index].auxAnswerDiffPercentage) { index++; }
      sorted.splice(index, 0, el);
      return sorted;
    }, []);
  }

  private sortDefautByReset(_originArray): any {
    if (this.question.answerType === 'QuestionBundle') {
        return this.sortAscendingByQuestionNumber(_originArray);
    } else {
        return this.sortAscendingByName(_originArray);
    }
  }

  private sortAscendingByQuestionNumber(_originArray): any {
    return _originArray.reduce((sorted, el) => {
        let index = 0;
        while (index < sorted.length && el.questionNumber > sorted[index].questionNumber) { index++; }
        sorted.splice(index, 0, el);
        return sorted;
      }, []);
  }

  private sortAscendingByName(_originArray): any {
    return _originArray.reduce((sorted, el) => {
        let index = 0;
        while (index < sorted.length && el.answerName > sorted[index].answerName) { index++; }
        sorted.splice(index, 0, el);
        return sorted;
    }, []);
  }

  private sortDescending(_originArray): any {
    return _originArray.reduce((sorted, el) => {
      let index = 0;
      while (index < sorted.length && Number(el.answerPercentage) < Number(sorted[index].answerPercentage)) { index++; }
      sorted.splice(index, 0, el);
      return sorted;
    }, []);
  }

  private sortDescendingPercentage(_originArray): any {

    _originArray.forEach(element => {
      element.auxAnswerDiffPercentage = !element.answerDiffPercentage && element.answerDiffPercentage != 0 ? 100 : element.answerDiffPercentage;
    });
    return _originArray.reduce((sorted, el) => {
      let index = 0;
      while (index < sorted.length && el.auxAnswerDiffPercentage < sorted[index].auxAnswerDiffPercentage) { index++; }
      sorted.splice(index, 0, el);
      return sorted;
    }, []);
  }

  private generateNizPitanja() {
    this.question.haveAnswered = 'Have Answered';
    this.question.haveNotAnswered = 'Have Not Answered';
    this.question.nizPitanja = this.questionValue.nizPitanja;
  }

  private changeListAnswerModel(_isOnTheme, listGrouped) {
    if (this.isCompareMode) {
      if (this.hasAnswerTheme && _isOnTheme) {
        this.questionValue.listAnswerModel = listGrouped;
        this.question.listAnswerModel = this.questionValue.listAnswerModel;
      } else {
        this.questionValue.listAnswerModel = this.questionValue.copyListAnswerModel;
        this.question.listAnswerModel = this.questionValue.listAnswerModel;
      }
    } else {
      this.question.listAnswerModel = listGrouped ? listGrouped : this.question.listAnswerModel;
    }
  }

  private changeListNizPitanja(_isOnTheme, listGrouped) {
    if (this.isCompareMode) {
      if (this.hasAnswerTheme && _isOnTheme) {
        this.questionValue.nizPitanja = listGrouped;
        this.question.nizPitanja = this.questionValue.nizPitanja;
      } else {
        this.questionValue.nizPitanja = this.questionValue.copyNizPitanja;
        this.question.nizPitanja = this.questionValue.nizPitanja;
      }
    } else {
      this.question.nizPitanja = listGrouped ? listGrouped : this.question.nizPitanja;
    }
  }

  _onTranslateAction() {
    this.onTranlateAction.emit(this.listSurveyVersion[0].surveyName);
  }
  onSelectPercent(state) {
    this.onPercentageSelect.emit(state);
  }
}



// WEBPACK FOOTER //
// ./src/app/routes/surveys/master-summary/charting/charting.component.ts